import * as yup from 'yup';

export const maxOrderQuantityFormSchema = yup.object({
  enterprise: yup
    .number()
    .required('Enterprise is required'),
  plant: yup.string().required('Plant is required'),
  matnr: yup.string().when('type', {
    is: (type: string) => type == '0',
    then: (schema) => schema.required('MATNR is required'),
  }),
  carton: yup
    .string()
    .required('Max Allowed Size is required'),
  duration: yup
    .string()
    .required('Time in days is required'),
  type: yup.string().required('Type is required'),
  brand: yup.string().when('type', {
    is: (type: string) => type == '1',
    then: (schema) => schema.required('Brand is required'),
  }),
  unit: yup.string(),
  periodFromStr: yup.date().required('Period is required'),
  periodToStr: yup.date(),
});

export type TMaxOrderQuantityFormData = yup.InferType<
  typeof maxOrderQuantityFormSchema
>;
